// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkout-register-session {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./src/app/components/_purpose-built-components/checkout-register-session/checkout-register-session.component.sass"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;AACF","sourcesContent":[".checkout-register-session\n  display: flex\n  align-items: center\n  gap: 0.5rem\n  white-space: nowrap\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
